<template>
  <div class="education">
    <ListTitle :title="title" :titleImg="titleImg" />
    <v-container class="py-12">
      <v-row class="d-flex justify-center align-center">
        <v-col>
          <div style="text-align:center">
            <span class="sectTitle2">Open API 介接服務開發說明</span>
          </div>
        </v-col>
      </v-row>
      <v-row class="d-flex justify-center align-center pt-12">
        <v-col lg="10">
          <div
            class="ct-text-subtitle3"
            style="text-align:center;line-height: 150%;"
          >
            為達到校園植樹資料流通的願景，開發符合「共通性應用程式介面規範」之網路服務，介接端透過指定方法及輸入參數的方式，可即時取得以Json格式回傳的樹種資訊，以滿足後續資料介接使用或加值服務之需求。
          </div>
        </v-col>
      </v-row>
    </v-container>
    <v-container class="py-12">
      <v-row class="d-flex justify-center align-center">
        <v-col>
          <div
            class="sect1-title mx-12 ct-text-h1 ct-text-bolder"
            style="text-align:center"
          >
            <span class="sectTitle2">校園樹種統計</span>
          </div>
        </v-col>
      </v-row>
      <v-row class="d-flex justify-center align-center pt-12">
        <v-col lg="10">
          <div
            class="ct-text-subtitle3"
            style="text-align:center;line-height: 150%;"
          >
            指定學校編號，回傳該學校所包含之樹種、個樹種之數量。(學校編號代碼請參考
            <a
              title="校園編號對應表.ods"
              :href="setSchoolFileStr()"
              download="校園編號對應表.ods"
              >此文件</a
            >
            。)
          </div>
        </v-col>
      </v-row>
    </v-container>
    <v-container style="margin-bottom:250px">
      <div
        v-for="(obj, idx) in apidata"
        :id="'sect_' + obj.API_Name"
        :key="idx"
      >
        <v-container fluid>
          <div class="ct-text-subtitle3 my-3">
            <label :for="'urlarea' + idx">詳細規格及指令如下：</label>
          </div>
          <!-- <span class="SA_text_title accent--text">{{
            idx + 1 + "." + obj.API_Name
          }}</span> -->
          <v-row>
            <v-col cols="10">
              <v-textarea
                :id="'urlarea' + idx"
                :value="apiStr(obj)"
                height="12"
                outlined
                dense
                background-color="white"
                hide-details
                readonly
              ></v-textarea>
            </v-col>
            <v-col
              cols="2"
              align-self="center"
              style="
                  display: flex;
                  align-items: center;
                  justify-content: center;
                "
            >
              <v-btn
                :color="'#FFF777'"
                class="ct-text-bolder d-flex justify-center align-stretch"
                @click="copyURL('urlarea' + idx)"
                >複製指令</v-btn
              >
            </v-col>
          </v-row>
        </v-container>
        <v-container fluid>
          <v-data-table
            :items="setTT(obj, 1)"
            :headers="paramHeader"
            hide-default-footer
            class="ct_datatable"
          >
            <template v-slot:item.說明="{ item }">
              <div v-html="TOOL.replaceUnitToRem(item.說明)"></div>
            </template>
          </v-data-table>
        </v-container>
        <v-container fluid>
          <div class="ct-text-subtitle3 my-3">
            <label :for="'samplearea' + idx">回傳結果範例：</label>
          </div>
          <v-row>
            <v-col cols="12">
              <v-textarea
                :id="'samplearea' + idx"
                outlined
                dense
                hide-details
                background-color="white"
                readonly
                :value="setResult(obj)"
              ></v-textarea>
            </v-col>
          </v-row>
        </v-container>
        <v-container fluid>
          <div class="ct-text-subtitle3 my-3">回傳資訊與說明如下：</div>
          <v-data-table
            :items="setTT(obj, 2)"
            :headers="outputHeader"
            hide-default-footer
            class="ct_datatable"
          ></v-data-table>
        </v-container>
      </div>
    </v-container>
    <Footer />
  </div>
</template>
<script>
import Footer from "@/components/layouts/footer.vue";
import ListTitle from "@/components/ui/searchList/ListTitle.vue";
//import ListGroup from "@/components/ui/searchList/ListGroup.vue";
export default {
  props: {
    title: {
      type: String,
      default: "Open Data"
    },
    titleImg: {
      type: String,
      default: "common/icon_open.svg"
    }
  },
  data() {
    return {
      itemList: [],
      open_statusAPI: [],
      apiobj: {},
      apiURL: this.$store.state.openData.apiURL,
      paramHeader: [
        {
          text: "參數",
          value: "參數",
          align: "left",
          scope: "col",
          sortable: false
        },
        {
          text: "必填/選填/預設",
          value: "必填/選填/預設",
          align: "left",
          scope: "col",
          sortable: false
        },
        {
          text: "說明",
          value: "說明",
          align: "left",
          scope: "col",
          sortable: false
        }
      ],
      outputHeader: [
        {
          text: "回傳欄位",
          value: "回傳欄位",
          align: "left",
          scope: "col",
          sortable: false
        },
        {
          text: "說明",
          value: "說明",
          align: "left",
          scope: "col",
          sortable: false
        }
      ]
    };
  },
  components: {
    Footer,
    ListTitle
    //ListGroup
  },
  computed: {
    apidata() {
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.open_statusAPI = [];
      for (let i = 0; i < this.$store.state.openData.data.length; i++) {
        // eslint-disable-next-line eqeqeq
        if (this.$store.state.openData.data[i].STATUS == 1) {
          // eslint-disable-next-line vue/no-side-effects-in-computed-properties
          this.open_statusAPI.push(this.$store.state.openData.data[i]);
        }
      }
      return this.open_statusAPI;
    }
  },
  mounted() {
    this.itemList = [];
    this.$store.dispatch("setDataUrlStr", this.$store.state.openData.data);

    this.open_statusAPI = this.$store.state.openData.data;
  },
  methods: {
    copyURL(id) {
      const apiURL = document.createRange();
      apiURL.selectNode(document.getElementById(id));
      const copy = window.getSelection();
      copy.removeAllRanges();
      copy.addRange(apiURL);
      document.execCommand("copy");
      alert("複製完成！");
      // ("複製完成！")
      // this._SAlert.Success("複製完成！");
      // setTimeout(() => {
      //   this._SAlert.Close();
      // }, 1000);
    },
    apiStr(apiobj) {
      return this.apiURL + "/" + apiobj.API_ACTION + "?" + apiobj.ParamUrlStr;
    },
    setTT(value, type) {
      let str = "";
      switch (value.API_Name) {
        case "標準郵遞地址(以地址查詢)":
          str = this.$store.state.openData["t1" + type];
          break;
        case "標準郵遞地址(以地址碼查詢)":
          str = this.$store.state.openData["t2" + type];
          break;
        case "水質資料(以濕地名稱查詢)":
          str = this.$store.state.openData["t3" + type];
          break;
        case "水質資料(以空間環域查詢)":
          str = this.$store.state.openData["t4" + type];
          break;
        default:
          str = "";
          break;
      }
      return str;
    },
    setResult(value) {
      let str = "";
      switch (value.API_Name) {
        case "標準郵遞地址(以地址查詢)":
          str = this.$store.state.openData.r11;
          break;
        case "標準郵遞地址(以地址碼查詢)":
          str = this.$store.state.openData.r21[0]["說明"];
          break;
        case "水質資料(以濕地名稱查詢)":
          str = this.$store.state.openData.r31;
          break;
        case "水質資料(以空間環域查詢)":
          str = this.$store.state.openData.r41[0]["說明"];
          break;
        default:
          str = "";
          break;
      }
      return str;
    },
    setSchoolFileStr() {
      return `${process.env.BASE_URL}` + "data/校園編號對應表.ods";
    }
  }
};
</script>
<style lang="scss" scoped>
.education {
  background-color: #f6edd9;
}
</style>
